export const getImage = (
  image: string | File,
  fallback = `/default-avatar.jpeg`,
) => {
  if (image instanceof File) {
    return URL.createObjectURL(image) || `/default-logo.png`;
  } else {
    return image || fallback;
  }
};

export const getFormEmbedHtml = (id: string) =>
  `
<div id="form" class="widget-container"></div>
<script src="${process.env.NEXT_PUBLIC_WIDGET_URL}/testify.umd.js"></script>
<script type="text/javascript">
    document.addEventListener("DOMContentLoaded", function() {
        window.WidgetSystem.init("form", {
            id: "form",
            props: {
                id: "${id}"
            },
        });
    });
</script>
`.trim();

export const changeFavicon = (url: string) => {
  const existingLinks = document.querySelectorAll("link[rel*='icon']");
  existingLinks.forEach((link) => link.remove());

  const favicon = document.createElement("link");
  favicon.rel = "shortcut icon";
  favicon.type = "image/svg+xml";
  favicon.href = url;

  const appleTouchIcon = document.createElement("link");
  appleTouchIcon.rel = "apple-touch-icon";
  appleTouchIcon.href = url;

  const head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(favicon);
  head.appendChild(appleTouchIcon);
};

export const changePageTitle = (title: string) => {
  const titleElement = document.querySelector("title")!;
  titleElement.innerHTML = title;
  document.title = title;

  const head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(titleElement);
};
